export default __webpack_public_path__ + "static/media/Sodebs1-min.2a88b0b8.PNG";